'use client';

import { Container } from '@aurora-components';
import type { FragmentType } from '@gql';
import { ContentPost } from 'components/aurora/content-post/content-post';
import type { ContentPostFragment } from 'lib/shared/content-posts-gql';

type Content = FragmentType<typeof ContentPostFragment>;
export function PageContainer({ post, locale }: { post: Content; locale: string }) {
  return (
    <Container $paddingTop={8} $paddingX={5} $maxWidth $fullHeight $centered>
      <ContentPost content={post} locale={locale} />
    </Container>
  );
}
